var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"useful-services useful-services_grey"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"useful-services__wr"},[_c('ClientOnly',[_c('CurrencyRatesTableSmall')],1),_vm._v(" "),_c('OfficesMapSmall')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }